import React, { Component } from "react";
import { PageHeader2, Contact, NewsBody } from "../components";
import axios from "axios";
import {
  API_DETAIL_PUBLICATIONS,
  API_DETAIL_PUBLICATIONS_BYID,
  API_MAIN,
} from "../utils/constants";

export class Detail_publication extends Component {
  constructor(props) {
    super(props);

    this.state = {
      detail: [],
      detail2: [],
      slug: "",
      main: [],
    };
  }

  componentDidMount() {
    this.getMain();
  }

  getData(slug) {
    const headers = {};
    axios
      .get(API_DETAIL_PUBLICATIONS + "?slug=" + slug, { headers: headers })
      .then((res) => {
        const detail = res.data.news;
        this.setState({ detail });
        if (this.state.main.LANG) {
          if (detail.LANG !== this.state.main.LANG) {
            if (detail.LANG_REF === 0 || detail.LANG_REF === "0") {
              window.location.href = "/";
            } else {
              axios
                .get(API_DETAIL_PUBLICATIONS_BYID + "?id=" + detail.LANG_REF, {
                  headers: headers,
                })
                .then((response) => {
                  const detail2 = response.data.news;
                  this.setState({ detail2 });
                  window.location.href = "/publication/" + detail2.SLUG;
                });
            }
          }
        }
      })
      .catch((error) => {
        console.log("Error yaa ", error);
      });
  }

  getMain() {
    const headers = {};
    axios
      .get(API_MAIN, { headers: headers })
      .then((res) => {
        const main = res.data.main;
        this.setState({ main });
        this.getData(this.props.match.params.slug);
      })
      .catch((error) => {
        console.log("Error yaa ", error);
      });
  }

  render() {
    const { detail, main } = this.state;
    const param = {
      title: detail.TITLE,
      subtitle: detail.SUB_TITLE,
      breadcrumb1: detail.TITLE,
      breadcrumb: "Publication",
      breadcrumbLink: "/publication/page/1",
    };

    return (
      <main>
        <div role="main" className="main">
          <PageHeader2 param={param} />
          <NewsBody param={detail} />
          <Contact data={main} />
        </div>
      </main>
    );
  }
}

export default Detail_publication;
